import { render, staticRenderFns } from "./selectworktype.vue?vue&type=template&id=3a194e81&"
import script from "./selectworktype.js?vue&type=script&lang=js&"
export * from "./selectworktype.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a194e81')) {
      api.createRecord('3a194e81', component.options)
    } else {
      api.reload('3a194e81', component.options)
    }
    module.hot.accept("./selectworktype.vue?vue&type=template&id=3a194e81&", function () {
      api.rerender('3a194e81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/inputs/selectworktype.vue"
export default component.exports